<template>
    <div class="popup popup-cancelRule" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  style="display: block;"  id="cancelRule">
        <div class="shorexDetail-title js-returnShorexBtn">
            <p>取消政策</p>
            <a class="shorexDetail-returnButton" @click="goBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="ruleDetail" id="cancelRuleDetail">
            <div class="packageRuleDetail" v-if="!isFortyEightHoursNrpCruise" >
                <div v-html="nrpDescription"></div>
                
                <div v-html="rpDescription"></div>
            </div>

            <div class="packageRuleDetail fortEightRule" v-else v-html="fortyEightHoursNrp">
                
            </div>

        </div>

    </div>
</template>

<script>
import nrpConfig from '@/utilities/nrpConfig'
export default {
    name: "CancelPolicy",
    props: {
        onGoBack: {
            type: Function
        },
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        isFortyEightHoursNrpCruise: {
            type: Boolean
        },
        showRow: {
            type: Boolean,
            default () {
                return false
            }
        },
    },
    methods: {
        goBack () {
            this.onGoBack()
        }
    },
    computed: {
        fortyEightHoursNrp() {
            return nrpConfig.fortyEightHoursNrp.description
        },
        nrpDescription () {
            // return nrpConfig.nrp.description
            if(this.showRow){
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyRow
                }else{
                    return this.$store.state.cruiseRow.nrpData.cancelPolicy
                }
        },
        rpDescription () {
            // return nrpConfig.rp.description
            if(this.showRow){
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyNrpRow
                }else{
                    return this.$store.state.cruiseRow.nrpData.cancelPolicyNrp
                }
        }
    }
}
</script>

<style lang="less" scoped>
.popup {
    position: fixed;
    background-color: #F6F7F8;
}
#cancelRule.modal-out {
    transform: translate3d(100%, 0, 0);
}
.shorexDetail-title {
    padding: 0px 20px;
		background-color: #fff;
		overflow: hidden;
		text-align: center;
		margin-bottom: 10px;
		position: fixed;
		width: 100%;
		z-index: 10;
		height: 50px;
    > p {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #333333;
        letter-spacing: 1px;
        text-align: center;
        margin: 0;
				line-height: 50px;
    }
    .shorexDetail-returnButton {
        width: 30px;
        position: absolute;
        top: 15px;
        left: 20px;
        text-align: left;
    }
    img {
        width: 33%;
    }
}

#cancelRuleDetail {
    margin-top: 50px;
		height: calc(100% - 50px);
}


</style>

<style lang="less">
#cancelRule {
	.packageRuleDetail {
			height: 100%;
			overflow: scroll;
			background: white;
			.cabinDetail-box {
					padding: 0 20px 62px;
					font-size: 12px;
					line-height: 20px;
					color: #666;
					letter-spacing: 0;
					.lineTitle {
							display: -webkit-box;
							display: -webkit-flex;
							display: -moz-box;
							display: -ms-flexbox;
							display: flex;
							-webkit-box-align: center;
							-webkit-align-items: center;
							-moz-box-align: center;
							-ms-flex-align: center;
							align-items: center;
							padding: 17px 0 7px;
							font-size: 14px;
							line-height: 20px;
							color: #4A90E2;
							font-weight: bold;
							.lineTitle-line {
									width: 3px;
									height: 12px;
									margin-right: 6px;
									background-color: #4A90E2;
							}
					}
					.cabinDetail-txt {
							.cabinDetail-txt-bold {
									font-weight: bold;
							}
					}
			}

            .bubbleInfoCon {
					padding: 0 20px 20px;
					font-size: 12px;
					line-height: 20px;
					color: #666;
					letter-spacing: 0;
					.bubbleInfoCon-title {
							display: -webkit-box;
							display: -webkit-flex;
							display: -moz-box;
							display: -ms-flexbox;
							display: flex;
							-webkit-box-align: center;
							-webkit-align-items: center;
							-moz-box-align: center;
							-ms-flex-align: center;
							align-items: center;
							padding: 17px 0 7px;
							font-size: 14px;
							line-height: 20px;
							color: #4A90E2;
							font-weight: bold;
					}
					
                    .normal_tips p{
                        margin: 0;
                        .blue{
                            color: #4A90E2;
                        }
                    }

                    .nrp_tips p{
                        margin: 0;
                        .blue{
                            color: #4A90E2;
                        }
                    }
			}
	}
}
</style>